import Util from '../../../forecast-app/shared/util/util';
import {FEATURE_FLAG_UI_STORAGE_KEY, pathForFeatureFlagUi, resolveStoredFeatureFlagUi} from './featureFlagUiPreference';

/**
 * Which feature flags screen to open right now, as an unprefixed path.
 *
 * Both Mission Control headers ask this when they build their Feature Flags tab, so the tab points at
 * the chosen screen directly rather than at the entry point. That keeps the entry point for what it is
 * good at — bookmarks and cold loads — and keeps a click from bouncing through a route whose only job
 * is to leave again.
 *
 * Separate from `featureFlagUiPreference` so that module stays free of `Util`, and with it of the
 * dependency graph `Util` drags in: everything there is a pure function over a stored value.
 */
export function featureFlagUiPathFromStorage(): string {
	return pathForFeatureFlagUi(
		resolveStoredFeatureFlagUi(Util.localStorageGetItemWithDefault(FEATURE_FLAG_UI_STORAGE_KEY, ''))
	);
}
